import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { StaffEventFacade } from '../+state/staff-event/staff-event.facade';
import { Observable } from 'rxjs';
import {
  StaffEventSkeleton,
  StaffEventAudit,
  StaffEventBusinessPersonAudit,
  ScheduledEventAudit
} from '../+models/staff-event-audit.model';
import { StaffEventAuditListComponent } from './staff-event-audit-list/staff-event-audit-list.component';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';

@Component({
  selector: 'sd-portal-staff-event-audit',
  templateUrl: './staff-event.component.html',
  styleUrls: ['./staff-event.component.scss']
})
export class StaffEventComponent implements OnInit {
  staffEventSkeletonsLoaded$: Observable<boolean>;
  staffEventSkeletonsLoading$: Observable<boolean>;
  staffEventSkeletons$: Observable<StaffEventSkeleton[]>;

  staffEventAuditsLoading$: Observable<boolean>;
  staffEventAuditsLoaded$: Observable<boolean>;
  staffEventAudits$: Observable<StaffEventAudit[]>;

  scheduledEventAuditsLoading$: Observable<boolean>;
  scheduledEventAuditsLoaded$: Observable<boolean>;
  scheduledEventAudits$: Observable<ScheduledEventAudit[]>;

  staffEventBusinessPersonAuditsLoading$: Observable<boolean>;
  staffEventBusinessPersonAuditsLoaded$: Observable<boolean>;
  staffEventBusinessPersonAudits$: Observable<StaffEventBusinessPersonAudit[]>;

  @ViewChildren(StaffEventAuditListComponent)
  staffEventAuditLists: QueryList<StaffEventAuditListComponent>;
  staffEventTypesLoaded$: Observable<boolean>;
  staffEventTypesLoading$: Observable<boolean>;
  staffEventTypes$: Observable<RefTypeItem[]>;

  constructor(private readonly staffEventFacade: StaffEventFacade) {}

  ngOnInit() {
    this.staffEventSkeletonsLoaded$ = this.staffEventFacade.staffEventSkeletonsLoaded$;
    this.staffEventSkeletonsLoading$ = this.staffEventFacade.staffEventSkeletonsLoading$;
    this.staffEventSkeletons$ = this.staffEventFacade.staffEventSkeletons$;

    this.staffEventAuditsLoading$ = this.staffEventFacade.staffEventAuditLoading$;
    this.staffEventAuditsLoaded$ = this.staffEventFacade.staffEventAuditLoaded$;
    this.staffEventAudits$ = this.staffEventFacade.staffEventAudits$;

    this.staffEventBusinessPersonAuditsLoading$ =
      this.staffEventFacade.staffEventBusinessPersonAuditLoading$;
    this.staffEventBusinessPersonAuditsLoaded$ =
      this.staffEventFacade.staffEventBusinessPersonAuditLoaded$;
    this.staffEventBusinessPersonAudits$ = this.staffEventFacade.staffEventBusinessPersonAudits$;

    this.scheduledEventAuditsLoading$ = this.staffEventFacade.scheduledEventAuditLoading$;
    this.scheduledEventAuditsLoaded$ = this.staffEventFacade.scheduledEventAuditLoaded$;
    this.scheduledEventAudits$ = this.staffEventFacade.scheduledEventAudits$;

    this.staffEventTypesLoaded$ = this.staffEventFacade.staffEventTypesLoaded$;
    this.staffEventTypesLoading$ = this.staffEventFacade.staffEventTypesLoading$;
    this.staffEventTypes$ = this.staffEventFacade.staffEventTypes$;

    this.staffEventFacade.loadStaffEvents();
  }

  loadStaffEventAudits(staffEventId: number) {
    this.staffEventFacade.loadStaffEventAudits(staffEventId);
  }

  nextStaffEventAuditPage(staffEventId: number) {
    this.staffEventFacade.nextStaffEventAuditPage(staffEventId);
  }

  loadScheduledEventAudits(scheduledEventId: number) {
    this.staffEventFacade.loadScheduledEventAudits(scheduledEventId);
  }

  nextScheduledEventAuditPage(scheduledEventId: number) {
    this.staffEventFacade.nextScheduledEventAuditPage(scheduledEventId);
  }

  staffEventOpened(staffEvent: StaffEventSkeleton) {
    setTimeout(() => {
      const match = this.staffEventAuditLists.find(
        c => c.staffEvent.staffEventId === staffEvent.staffEventId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadStaffEventBusinessPersonAudits(staffEventBusinessPersonId: number) {
    this.staffEventFacade.loadStaffEventBusinessPersonAudits(staffEventBusinessPersonId);
  }

  nextStaffEventBusinessPersonAuditPage(staffEventBusinessPersonId: number) {
    this.staffEventFacade.nextStaffEventBusinessPersonAuditPage(staffEventBusinessPersonId);
  }
}
